module.exports = __webpack_public_path__ + "static/media/58_BM_block-link.ecdcce01.png";